import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { getCleanedUrlParams, showError } from '@utils';
import { useQuery } from 'react-query';
import { QUERY_KEYS } from 'constants/queryKeys';
import { vendorsServices } from '@services';
import { getVendorsQueryParams, normalizeTeams } from './utils';

export const VENDORS_PER_PAGE = 50;

export const useVendorsOperations = (enableFetch = true) => {
  const router = useRouter();

  const page = router.query?.page || 1;
  const order = router.query?.order;
  const orderBy = router.query?.orderBy;
  const pageSize = router.query?.pageSize || VENDORS_PER_PAGE;

  const params = {
    pageSize: parseInt(pageSize, 10) || VENDORS_PER_PAGE,
    orderBy,
    order,
    page,
  };

  const cleanParams = getVendorsQueryParams(params);

  const vendorsResponse = useQuery(
    [QUERY_KEYS.GET_VENDORS_KEY, cleanParams],
    () => vendorsServices.getVendors(getCleanedUrlParams(params)),
    { enabled: enableFetch, refetchOnMount: true }
  );

  const vendors = normalizeTeams(vendorsResponse?.data?.data || []);

  useEffect(() => {
    if (vendorsResponse.isError) {
      showError(vendorsResponse?.error);
    }
  }, [vendorsResponse.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    page,
    pageSize: parseInt(pageSize, 10) || VENDORS_PER_PAGE,
    total: vendorsResponse?.data?.meta?.total,
    loading: vendorsResponse?.isLoading,
    vendors,
    hasError: vendorsResponse?.isError,
    errorMessage: vendorsResponse?.error,
    getVendors: vendorsResponse.refetch,
  };
};
